import React from 'react'
import MeyerLogo from '../static/FooterPartner/MeyerLogo-80h.png'
import LotusLogo from '../static/FooterPartner/lotus-logo.png'
import StantonLogo from '../static/FooterPartner/stanton-logo.png'
import InovationLearningLogo from '../static/FooterPartner/InnivationLearningLogo.png'
import HomeTownEventsLogo from '../static/FooterPartner/HometownEvents.png'
import FoxLakeLogo from '../static/FooterPartner/FoxLakeLogo.png'
import ISILogo from '../static/FooterPartner/ISILogo.png'


export default function PartnerIcons() {
   return (
    <p className="d-flex flex-row justify-content-around">
        <a href="https://www.isi-services.com/" target="_blank" rel="noreferrer">
        <img
          className="img-fluid mb-4 pl-0 partner"
          src={ISILogo}
          alt='International Services, Inc. | Staffing Solutions'
        />
      </a>
       <a href="https://foxlake.org/120/Parks-Recreation" target="_blank" rel="noreferrer">
        <img
          className="img-fluid mb-4 pl-0 partner"
          src={FoxLakeLogo}
          alt='Inovation Learning'
        />
      </a>
      <a href="https://www.innovationlearning.com/" target="_blank" rel="noreferrer">
        <img
          className="img-fluid mb-4 pl-0 partner"
          src={InovationLearningLogo}
          alt='Inovation Learning'
        />
      </a>
      <a href="https://www.d114.org/middle-school" target="_blank" rel="noreferrer">
        <img
          className="img-fluid mb-4 pl-0 partner"
          src={StantonLogo}
          alt='Stanton School'
        />
      </a>
      <a href="https://www.sd735.org/meyer" target="_blank" rel="noreferrer">
        <img
          className="img-fluid mb-4 pl-0 partner"
          src={MeyerLogo}
          alt='Elizabeth Meyer School'
        />
      </a>
      <a href="https://www.facebook.com/Hometowneventspopup/" target="_blank" rel="noreferrer">
        <img
          className="img-fluid mb-4 pl-0 partner"
          src={HomeTownEventsLogo}
          alt='Home Town Events'
        />
      </a>
      <a href="https://www.d114.org/elementary-school" target="_blank" rel="noreferrer">
        <img
          className="img-fluid mb-4 pl-0 partner"
          src={LotusLogo}
          alt='Lotus Elementary School'
        />
      </a>
    </p>
   )
}
